import { freightHandlingUnitIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const setDefaultFreightHandlingUnit = {
  name: "setDefaultFreightHandlingUnit" as const,
  input: z.object({ id: freightHandlingUnitIdFormat.schema }),
  output: z.object({}),
};
